import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://soebfmzxlzjrjrfsfqtl.supabase.co"
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvZWJmbXp4bHpqcmpyZnNmcXRsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0Nzc4NjQsImV4cCI6MjA5MzA1Mzg2NH0.epDPDDwaTZSUXdzK1vD2CYMSIrPLrBglnBCuOzNWzr4"

export const supabase = createClient(supabaseUrl, supabaseKey)